import { Button, Modal } from "@4uhub/lib4uhub";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import {
  Box,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Tooltip,
} from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import useCopy from "../../../../hooks/useCopy";

const translationPath = "4uESign.page.automations.emailSendRules.";

interface IAvailableVariablesModalProps {
  open: boolean;
  onClose: () => void;
}

const variables = [
  { nameKey: "variables.patient_name", value: "{{NOME_PACIENTE}}" },
  {
    nameKey: "variables.encounter_number",
    value: "{{NUMERO_ATENDIMENTO}}",
  },
];

export const AvailableVariablesModal = memo(
  ({ open, onClose }: IAvailableVariablesModalProps) => {
    const { t } = useTranslation();
    const { copy } = useCopy();

    return (
      <Modal
        open={open}
        onClose={onClose}
        title={
          t(translationPath + "available_variables") || "Available variables"
        }
      >
        <Box pt={2} minWidth={{ xs: "100%", sm: 480 }}>
          <Stack spacing={2}>
            <List disablePadding>
              {variables.map((variable) => (
                <ListItem
                  key={variable.value}
                  sx={{
                    mb: 1.5,
                    px: 2,
                    py: 1.5,
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 1,
                  }}
                  secondaryAction={
                    <Tooltip title={t(translationPath + "copy_variable")}>
                      <IconButton
                        edge="end"
                        size="small"
                        onClick={() => copy(variable.value)}
                      >
                        <ContentCopyRoundedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  }
                >
                  <ListItemText
                    primary={t(translationPath + variable.nameKey)}
                    secondary={
                      <Chip
                        size="small"
                        variant="outlined"
                        color="primary"
                        label={variable.value}
                        sx={{ mt: 1 }}
                      />
                    }
                    sx={{ pr: 5 }}
                  />
                </ListItem>
              ))}
            </List>

            <Stack direction="row" justifyContent="flex-end">
              <Button variant="outlined" onClick={onClose}>
                {t(translationPath + "close")}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    );
  },
);
